
import React from "react";
import { Helmet } from "react-helmet-async";
import PurchasedAgents from "@/components/dashboard/PurchasedAgents";
import { Agent } from "@/models/agent";

const Dashboard: React.FC = () => {
  // Dummy data for purchased agents with complete Agent properties
  const purchasedAgents: Agent[] = [
    {
      id: "1",
      name: "AI Writer",
      description: "A powerful AI for generating creative content.",
      category: "Writing",
      tags: ["ai", "writing", "content"],
      pricingModel: "paid",
      price: 19.99,
      owner_id: "creator-1",
      fullDescription: "AI Writer is a powerful tool for generating creative content.",
      features: ["Feature 1", "Feature 2"],
      useCases: ["Use case 1", "Use case 2"],
      requirements: "None",
      version: "1.0.0",
      license: "MIT",
      isPublic: true,
      downloads: 100,
      createdAt: new Date(),
    },
    {
      id: "2",
      name: "Data Analyzer",
      description: "Analyzes data and provides insights.",
      category: "Data Analysis",
      tags: ["data", "analysis"],
      pricingModel: "free",
      owner_id: "creator-2",
      features: ["Feature 1", "Feature 2"],
      useCases: ["Use case 1", "Use case 2"],
      version: "1.0.0",
      isPublic: true,
      createdAt: new Date(),
    },
  ];

  return (
    <>
      <Helmet>
        <title>Dashboard - OGMAI</title>
      </Helmet>
      <div className="container mx-auto p-6">
        <h1 className="text-3xl font-bold mb-6">Dashboard</h1>
        <p className="text-muted-foreground">
          Welcome to your dashboard. Here you can see an overview of your
          purchased agents and account activity.
        </p>

        {/* Purchased Agents Section */}
        <PurchasedAgents agents={purchasedAgents} />
      </div>
    </>
  );
};

export default Dashboard;
